import React from "react";
import { DiffOffset } from "../../../reducers/uploadedBoard";
import { xyformatting } from "../../../utils/valueFormatting";
import Icon from "../../common/Icon";
import { OffsetContainer } from "./RevisionsStyles";

export default function OffsetDetails({ offset }: { offset: DiffOffset }) {
  if (offset.x_mm === 0 && offset.y_mm === 0) {
    return null;
  }
  return (
    <OffsetContainer>
      <div>
        <Icon src={"/icons/warn.svg"} alt={"Warning"} />
      </div>
      <div>
        An offset of ({xyformatting(offset.x_mm, offset.y_mm, "mm")}) was
        applied to the previous board when this diff was calculated.
      </div>
    </OffsetContainer>
  );
}
